import { useContext } from 'react'

import Context from './Context'

const useBreadcrumbs = () => {
  return useContext(Context)
}

export default useBreadcrumbs
